module.exports = __webpack_public_path__ + "media/images/shark/Naranjo_9201-p-500-cc842b346a39392b266bc3a02b09742d.jpeg";